import { FC, useState } from 'react';
import { ClickAwayListener, Popper } from '@material-ui/core';
import { useAppDispatch, useAppSelector } from 'redux/reduxHooks';
import { ReactComponent as DropdownVector } from 'assets/icons/dropdown-vector.svg';
import styles from './NavigationLink.module.scss';
import { logoutThunk } from 'redux/authSlice';
import { signOut } from 'firebase/auth';
import { auth } from 'services/firebase';
import Avatar from '../Avatar/Avatar';

interface NavigationLinkProps {}

const NavigationLink: FC<NavigationLinkProps> = () => {
  const { isLoggedIn } = useAppSelector((state) => state.authSlice);
  const dispatch = useAppDispatch();

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const onLogout = async () => {
    await signOut(auth);
    await dispatch(logoutThunk());
    setAnchorEl(null);
  };

  return isLoggedIn ? (
    <>
      <button
        className={styles['avatar-container']}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <Avatar />
        <DropdownVector />
      </button>
      <Popper
        open={!!anchorEl}
        anchorEl={anchorEl}
        placement="bottom"
        modifiers={{
          offset: {
            enabled: true,
            offset: '-40, 10',
          },
        }}
        className={styles['popper']}
      >
        <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
          <button className={styles['drop-down']} onClick={onLogout}>
            Sign out
          </button>
        </ClickAwayListener>
      </Popper>
    </>
  ) : null;
};

export default NavigationLink;
